import React from 'react';
import { LinearProgress } from '@mui/material';
import { colors } from '../../utils/colors';

const LoadingProgress = ({ loading }) => {
  if (!loading) return null;

  return (
    <LinearProgress
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        height: 3,
        backgroundColor: colors.alpha.black04 || 'rgba(0,0,0,0.04)',
        '& .MuiLinearProgress-bar': {
          backgroundColor: colors.primary.main || '#0958d9'
        }
      }}
    />
  );
};

export default LoadingProgress;
